import React, { useState } from "react";

import PropTypes from "prop-types";

import "./bola-nmero-inativa.css";

const BolaNmeroInativa = (props) => {
  const [isAtivo, setIsAtivo] = useState(false);
  return (
    <div className={`bola-nmero-inativa-container ${props.rootClassName} `}>
      <img
        alt="image"
        src="/lp/economiadacooperacao/Secao3/bolinha-200h.png"
        className="bola-nmero-inativa-image"
      />
      <span className="bola-nmero-inativa-text Exo2-H3">{props.numero}</span>
    </div>
  );
};

BolaNmeroInativa.defaultProps = {
  numero: "1",
  rootClassName: "",
};

BolaNmeroInativa.propTypes = {
  numero: PropTypes.string,
  rootClassName: PropTypes.string,
};

export default BolaNmeroInativa;
